module.exports = __webpack_public_path__ + "img/check.d28fd945.svg";